import { gql } from '@apollo/client';

// DSP运营数据汇总查询
export const GET_DSP_OPERATIONAL_SUMMARY = gql`
  query GetDspOperationalSummary($filter: DspOperationalDataFilterTypeInput!) {
    getDspOperationalSummary(filter: $filter) {
      totalPackages
      receivedPackages
      deliveredPackages
      deliveryRate
      deliveringPackages
      failedPackages
      returnedPackages
      transferredIn
      calculatedAt
    }
  }
`;

// DSP司机运营数据列表查询（分页）
export const GET_DSP_DRIVER_OPERATIONAL_LIST = gql`
  query GetDspDriverOperationalList($filter: DspOperationalDataFilterTypeInput!, $pageRequest: DailyTaskPageRequestTypeInput!) {
    getDspDriverOperationalList(filter: $filter, pageRequest: $pageRequest) {
      content {
        driverId
        driverName
        totalPackages
        receivedPackages
        deliveredPackages
        failedPackages
        deliveryRate
        deliveringPackages
        returnedPackages
        transferredIn
        calculatedAt
        lastDeliveryTime
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// DSP运营数据汇总响应类型
export interface DspOperationalSummary {
  totalPackages: number;
  receivedPackages: number;
  deliveredPackages: number;
  deliveryRate: number;
  deliveringPackages: number;
  failedPackages: number;
  returnedPackages: number;
  transferredIn: number;
  calculatedAt?: number | null;
}

// DSP司机运营数据类型
export interface DspDriverOperationalData {
  driverId: number;
  driverName: string;
  totalPackages: number;
  receivedPackages: number;
  deliveredPackages: number;
  failedPackages: number;
  deliveryRate: number;
  deliveringPackages: number;
  returnedPackages: number;
  transferredIn: number;
  calculatedAt?: number | null;
  lastDeliveryTime?: number | null;
}

// 查询响应类型
export interface DspOperationalSummaryResponse {
  getDspOperationalSummary: DspOperationalSummary;
}

export interface DspDriverOperationalListResponse {
  getDspDriverOperationalList: {
    content: DspDriverOperationalData[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}

// 排序选项枚举
export enum SortOption {
  DELIVERY_RATE = 'deliveryRate',
  FAILED_PACKAGES = 'failedPackages',
  RECEIVED_PACKAGES = 'receivedPackages'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

// DSP司机包裹详情列表查询
export const GET_DSP_DRIVER_PACKAGES = gql`
  query GetDspDriverPackages($filter: DspDriverPackagesFilterTypeInput!, $pageRequest: DailyTaskPageRequestTypeInput!) {
    getDspDriverPackages(filter: $filter, pageRequest: $pageRequest) {
      packages {
        orderId
        trackingNumber
        deliveryDriverId
        driverName
        taskNumber
        status
        recipientAddress
        deliveredAt
        failAt
        exceptionReasonCode
        deliveryAttempts
        orderNote {
          id
          note
          lang
          orderNoteTranslations {
            lang
            translateNote
          }
        }
      }
      deliveringCount
      deliveredCount
      failedCount
      returnedCount
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// DSP包裹数据类型
export interface DspPackageData {
  orderId: string;
  trackingNumber: string;
  deliveryDriverId?: number | null;
  driverName: string;
  taskNumber: string;
  status: string;
  recipientAddress?: string;
  deliveredAt?: number;
  failAt?: number;
  exceptionReasonCode?: string;
  deliveryAttempts: number;
  orderNote?: {
    id: number;
    note: string;
    lang: string;
    orderNoteTranslations: Array<{
      lang: string;
      translateNote: string;
    }>;
  };
}

// DSP司机包裹列表响应类型
export interface DspDriverPackagesResponse {
  getDspDriverPackages: {
    packages: DspPackageData[];
    deliveringCount: number;
    deliveredCount: number;
    failedCount: number;
    returnedCount: number;
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}
